import type { TopLevelRouteKind } from './topLevelRouteClassifier'
import type { WorkspaceRole } from '../types/workspace'

export const resolveFamilyConsoleRedirect = (input: {
  isAuthenticated: boolean
  isHelper: boolean
  isFamilyOnly: boolean
  activeRole?: WorkspaceRole | null
  topLevelRouteKind: TopLevelRouteKind
}): string | null => {
  if (!input.isAuthenticated) return null
  if (input.isHelper) return null
  if (input.topLevelRouteKind !== 'console') return null
  if (input.isFamilyOnly) return '/family'
  if (input.activeRole === 'LEARNER') return '/family'
  return null
}
